var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero is-fullheight",staticStyle:{"background-color":"#fbfbfb"}},[_c('div',{staticClass:"hero-head"},[_c('top-navbar'),_c('dashboard-content')],1),_c('div',{staticClass:"hero-foot"},[_c('content-footer')],1),_c('message-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }